import type { ReactNode } from 'react';

interface SectionProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
}

export function Section({ title, description, actions, children }: SectionProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-start justify-between gap-3">
        <div className="flex flex-col gap-1">
          <h2 className="text-[26px] leading-8 font-semibold text-text-primary">{title}</h2>
          {description && <p className="text-[15px] leading-6 text-text-secondary">{description}</p>}
        </div>
        {actions}
      </div>
      {children}
    </div>
  );
}
